<template>
  <el-avatar class="pointer" :src="userImg || $store.state.defaultPhoto" :size="size" @click.native="handleAvatarClick"></el-avatar>
</template>
<script>
import { baseUrl } from "@/config/env.js"
export default {
  props: ['imgSrc', 'userId', 'size'],
  computed: {
    userImg() {
      if(this.imgSrc) {
        if(this.imgSrc.startsWith('/')) {
          return baseUrl + this.imgSrc
        }else {
          return this.imgSrc
        }
      }else {
        return null
      }
    }
  },
  methods: {
    handleAvatarClick() {
      if(!this.userId) return
      if (this.userId == this.$store.state.user.id) {
        this.$router.push({ name: 'gridList', query: { id: this.userId, type: 'myRecommend' } });
      } else {
        this.$api.UserFans.AddUserFansVisitorLog(this.userId).then(res => {
          if (res && res.isSuccess) {
            this.$router.push({ name: 'gridList', query: { id: this.userId, type: 'myRecommend' } });
          }
        })
      }
    }
  }
}
</script>